<template>
  <div class="text-center mb-1">
    <GjIcon
      class="mb-1"
      name="Globe"
      size="57"
    />
    <template v-if="hasOrganizations">
      <h4 class="mb-1 text-main">
        Choose an organization
      </h4>
    </template>
    <template v-else>
      <h4 class="mb-1 text-main">
        Create a new Organization
      </h4>
    </template>
    <p class="col-12 col-md-8 m-auto text-center text-secondary mb-3">
      Organizations let you collaborate with team members, add permissions and share resources across your whole team under a shared billing account.
    </p>
  </div>
</template>
<script>
export default {
  name: 'OrganizationViewHeader',
  props: {
    hasOrganizations: {
      type: Boolean,
      require: true,
    },
  },
}
</script>
